class ConfigLoader {
  static instance = null;
  
  constructor() {
    if (ConfigLoader.instance) {
      return ConfigLoader.instance;
    }
    this.config = null;
    this.loaded = false;
    ConfigLoader.instance = this;
  }

  async loadConfig() {
    if (this.loaded) {
      return this.config;
    }

    try {
      const response = await fetch('/Config/maintenance.json');
      
      if (!response.ok) {
        console.warn('Config file not found or error loading');
        this.config = { maintenance: false };
        this.loaded = true;
        return this.config;
      }
      
      const data = await response.json();
      this.config = data;
      this.loaded = true;
      
      return data;
    } catch (error) {
      console.warn('Failed to load config file:', error);
      this.config = { maintenance: false };
      this.loaded = true;
      return this.config;
    }
  }

  getConfig() {
    return this.config;
  }

  isMaintenanceMode() {
    return this.config?.maintenance === true;
  }
}

export default new ConfigLoader();